import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import socialReducer from './socialSlice';
import transactionsReducer from './transactionsSlice';
import walletServiceFeesReducer from './walletServiceFeesSlice';
import merchantReducer from "./merchantSlice";
import paymentsReducer from "./paymentsSlice";
import ratesReducer from "./ratesSlice";
import webhooksReducer from "./webhookSlice";






export const store = configureStore({
  reducer: {
    auth: authReducer,
    social: socialReducer, 
    transactions: transactionsReducer,
    walletServiceFees: walletServiceFeesReducer,
    merchant: merchantReducer,
payments: paymentsReducer,
webhooks: webhooksReducer,
rates: ratesReducer,

  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
